import { CKLayoutGrid } from 'clearkit';

import { WhenProspector } from '../../policies/WhenProspector';
import { ContactSales } from '../CallsToAction/ContactSales';
import { FetchErrorRetry } from '../CallsToAction/FetchErrorRetry';
import { Listing } from '../Listing';
import { Loading } from '../Loading';
import { DeleteProspectList } from '../Modals/DeleteProspectList';
import { RenameProspectList } from '../Modals/RenameProspectList';
import { ProspectorSidebar } from '../Sidebar/ProspectorSidebar';
import { SidebarFilters } from '../Sidebar/SidebarFilters';
import { SidebarLists } from '../Sidebar/SidebarLists';
import { useProspector } from '../useProspector';
import { ProspectorProvider } from '../useProspector/Provider';

const LoadingSidebar = () => (
  <ProspectorSidebar>
    <ProspectorSidebar.Footer />
  </ProspectorSidebar>
);

export function ProspectorShowPage() {
  return (
    <WhenProspector cta={<ContactSales />}>
      <ProspectorProvider>
        <CKLayoutGrid className="w-full" gap="0" gridTemplateColumns="auto 1fr">
          <Prospector />
        </CKLayoutGrid>
      </ProspectorProvider>
    </WhenProspector>
  );
}

function Prospector() {
  const [state] = useProspector();

  const { showFilterSidebar } = state.context;

  if (state.matches('loading')) {
    return (
      <>
        <LoadingSidebar />
        <Loading />
      </>
    );
  } else if (state.matches('error')) {
    return (
      <>
        <LoadingSidebar />
        <FetchErrorRetry />
      </>
    );
  }

  return (
    <>
      {showFilterSidebar ? <SidebarFilters /> : <SidebarLists />}
      <Listing />
      <RenameProspectList />
      <DeleteProspectList />
    </>
  );
}
